import { lazy, Suspense } from "react";

// The map library is large, so it loads in its own file after the page itself has appeared.
const Explore = lazy(() => import("./ExploreMap").then((m) => ({ default: m.ExploreMap })));
const Mini = lazy(() => import("./ExploreMap").then((m) => ({ default: m.MiniMap })));

export const ExploreMap = (props) => (
  <Suspense fallback={<div style={{ position: "absolute", inset: 0, background: "#edf1ea" }} data-testid="map-loading" />}>
    <Explore {...props} />
  </Suspense>
);

export const MiniMap = (props) => (
  <Suspense fallback={<div style={{ height: props.height || 200, background: "#edf1ea" }} />}>
    <Mini {...props} />
  </Suspense>
);
